var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup318(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_318",
    "data-name": "Group 318",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12.737,
    viewBox: "0 0 12 13.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_122",
    "data-name": "Rectangle 122",
    width: 12,
    height: 12.737,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M5.983,193.64H.259c-.26,0-.273,0-.252-.265a5.206,5.206,0,0,1,3.083-4.539,4.653,4.653,0,0,1,.89-.312.219.219,0,0,1,.236.063c.2.2.393.4.595.594a.316.316,0,0,1,.084.255c0,.834,0,1.669,0,2.5a.66.66,0,0,0,.215.529c.214.2.413.412.622.616a.343.343,0,0,0,.549,0c.214-.207.416-.426.634-.628a.627.627,0,0,0,.2-.5c0-.828,0-1.657-.005-2.485a.432.432,0,0,1,.148-.352c.176-.162.344-.333.508-.507a.259.259,0,0,1,.3-.079,5.219,5.219,0,0,1,3.8,3.878,4.42,4.42,0,0,1,.141,1c.008.219,0,.227-.222.227H5.983",
    transform: "translate(0 -180.903)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M77.146,0a2.973,2.973,0,0,1,3,3.005,3.009,3.009,0,0,1-6.018,0A2.974,2.974,0,0,1,77.146,0",
    transform: "translate(-71.135 -0.001)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M139.591,227.686c0,.268,0,.537,0,.805a.9.9,0,0,1-.369.5.1.1,0,0,1-.05,0,.955.955,0,0,1-.371-.479q0-.832,0-1.663c0-.043-.021-.1.036-.123s.069.032.1.057a.354.354,0,0,0,.516,0c.031-.025.055-.074.1-.059s.037.079.037.122c0,.28,0,.56,0,.84",
    transform: "translate(-133.193 -217.567)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M126.61,184.864c.268,0,.535,0,.8,0,.039,0,.088-.01.108.036s-.019.075-.047.1c-.263.264-.527.526-.789.791-.064.064-.116.058-.177,0-.258-.261-.519-.518-.777-.779-.03-.031-.082-.061-.053-.116s.072-.031.111-.032c.274,0,.547,0,.821,0",
    transform: "translate(-120.597 -177.4)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup318);
export default __webpack_public_path__ + "static/media/Group318.1cd283200cc56d005fad5fd484c4a767.svg";
export { ForwardRef as ReactComponent };